import { post, patch, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, { mutate } from 'swr'
import { handleApiResponse } from './api_util';

async function getMerchants() {

  const payload = {
    apiName: 'LivisiblyMerchantApi',
    path: 'merchants'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetMerchants(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'MERCHANTS' : null,
    (path) => getMerchants()
  );
  return result;
}

export function refetchCaseMerchants() {
  mutate('MERCHANTS');

}



